import React, { useEffect, useRef, useState } from "react"
import i18n from "lib/i18n"

const GiftAidTooltip = () => {
  const [open, setOpen] = useState(false)
  const tooltipRef = useRef(null)

  /*
   * Sourced from the `useOutsideClick` hook from `tc`'s `/frontend`.
   * Close the tooltip when clicking outside of it.
   */
  useEffect(() => {
    const listener = (event) => {
      if (!tooltipRef.current?.contains(event.target)) {
        setOpen(false)
      }
    }
    document.addEventListener("click", listener, true)
    return () => {
      document.removeEventListener("click", listener, true)
    }
  }, [])

  return (
    <div className="relative inline-block">
      <button
        type="button"
        className="cursor-pointer border-0 bg-white pl-0 text-sm font-normal underline"
        onClick={() => setOpen(!open)}
      >
        {i18n.t("donation.label.gift_aid_checkbox_hint")}
      </button>

      {open && (
        <div
          className="absolute top-8 left-1/2 z-10 w-64 -translate-x-1/2 cursor-default rounded-md bg-white px-6 py-4 outline-1 outline-gray-100 drop-shadow-xl outline-solid sm:w-80"
          role="tooltip"
          ref={tooltipRef}
        >
          <p className="mb-0 pb-1 text-sm text-gray-900">
            {i18n.t("donation.tooltip.gift_aid.header")}
          </p>
          <p className="mb-0 pb-1 text-xs leading-relaxed text-gray-900">
            {i18n.t("donation.tooltip.gift_aid.body")}
          </p>
          <button
            type="button"
            className="mt-3 cursor-pointer rounded-xs border-0 bg-blue-600 px-5 py-2 text-white transition hover:bg-gray-200"
            onClick={() => setOpen(false)}
          >
            {i18n.t("donation.tooltip.gift_aid.button")}
          </button>
        </div>
      )}
    </div>
  )
}

export default GiftAidTooltip
